module.exports = __webpack_public_path__ + "img/best2pay.635d2a7a.png";